export type PdpVariantPersistenceAction =
  | { type: "set"; key: string }
  | { type: "clear" }
  | { type: "none" }

export type ResolvedPdpSelection = {
  selected_key: string | null
  persistence: PdpVariantPersistenceAction
}

export const pdpVariantCookieName = (productId: string) => `vp_pdp_${productId}`

export function resolvePdpSelection(input: {
  requestedKey?: string
  cookieKey?: string
  resolvedKey: string | null
  contentResolved: boolean
}): ResolvedPdpSelection {
  const selectedKey = input.contentResolved ? input.resolvedKey : null

  if (input.requestedKey !== undefined) {
    if (input.requestedKey === "default") {
      return {
        selected_key: null,
        persistence: { type: "clear" },
      }
    }

    if (
      input.contentResolved &&
      input.resolvedKey === input.requestedKey
    ) {
      return {
        selected_key: input.resolvedKey,
        persistence: { type: "set", key: input.resolvedKey },
      }
    }

    return {
      selected_key: selectedKey,
      persistence: { type: "none" },
    }
  }

  if (input.cookieKey !== undefined) {
    if (!input.contentResolved) {
      return {
        selected_key: null,
        persistence: { type: "none" },
      }
    }

    if (input.resolvedKey === input.cookieKey) {
      return {
        selected_key: input.resolvedKey,
        persistence: { type: "none" },
      }
    }

    return {
      selected_key: input.resolvedKey,
      persistence: { type: "clear" },
    }
  }

  return {
    selected_key: selectedKey,
    persistence: { type: "none" },
  }
}
